import { Typography } from '@global-engineering-shared/gweb-material-ui';

import DetailsCard from 'components/DetailsCard';
import ChipListDetail from 'features/EntityDetails/components/EntityDetails/ChipListDetail';
import { Tag } from 'types/detailsEntityType';

type TagsCardProps = {
  tags: Tag[] | null;
  previousTags?: Tag[] | null;
};

const TagsCard = ({ tags, previousTags }: TagsCardProps) => {
  const shouldShowTags = (tags && tags.length > 0) || (previousTags && previousTags.length > 0);

  return (
    <DetailsCard
      title="TAGS"
      detailsRows={[
        shouldShowTags ? (
          <ChipListDetail
            headerText="Tags"
            items={tags}
            previousItems={previousTags}
            getKey={(tag: Tag): string => tag.id || 'Unknown ID'}
            getLabel={(tag: Tag): string => tag.name || 'Unknown Name'}
            getTooltip={(tag: Tag): string[] => [`Tag ID: ${tag.id || 'Unknown ID'}`]}
          />
        ) : (
          <Typography variant="body2" fontWeight={400}>
            No Tags
          </Typography>
        ),
      ]}
    />
  );
};

export default TagsCard;
